var $ = require('../internals/export');

var of = require('../internals/collection-of'); // `WeakMap.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of


$({
  target: 'WeakMap',
  stat: true
}, {
  of: of
});